module.exports = "<h4 class=\"ui header\" [class.blue]=\"taskSvc.selectedItem.id\" [class.green]=\"!taskSvc.selectedItem.id\">\n  <i class=\"check icon\"></i>\n  <div class=\"content\">\n    {{taskSvc.checkedsTitle}}\n    <div class=\"sub header\">{{taskSvc.selectedItem.description}}</div>\n  </div>\n</h4>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/component/work/header/work-header.cmp.html
 ** module id = 396
 ** module chunks = 0
 **/